import AppFormModal from "@richbeauty/core/AppFormModal";
import useConvertToUserModalFieldsConfig from "./useConvertToUserModalFieldsConfig";
import IntlMessages from "@richbeauty/utility/IntlMessages";
import { forwardRef, useMemo } from "react";
import { toast } from "react-hot-toast";
import { revalidateCustomerLeads, revalidateCustomerLeadNotes } from "@richbeauty/utility/helper/cacheRevalidator";
import useConvertFromLead from "hooks/apis/users/useConvertFromLead";
import moment from "moment";

const ConvertToUserModal = forwardRef(({ leadData }, ref) => {
    const fieldsConfig = useConvertToUserModalFieldsConfig(leadData);
    const { trigger, isMutating } = useConvertFromLead();

    const handleConvertToUser = (formData) => {
        trigger(
            { ...formData, customerLeadId: leadData.id, roleId: "customer" },
            {
                onSuccess: () => {
                    revalidateCustomerLeads();
                    revalidateCustomerLeadNotes(leadData.id);
                    ref.current?.closeModal();
                    toast.success("Converted to user successfully");
                },
                onError: (error) => toast.error(error?.message),
            }
        );
    };

    const formatLeadData = useMemo(() => {
        return {
            ...leadData,
            dob: leadData.dob ? moment(leadData.dob) : undefined,
        };
    }, [leadData]);

    return (
        <AppFormModal
            ref={ref}
            data={formatLeadData}
            title={<IntlMessages id="app.customerLeads.convertToUser" />}
            fieldsConfig={fieldsConfig}
            onFinish={handleConvertToUser}
            isSubmitting={isMutating}
        />
    );
});

export default ConvertToUserModal;
